import React from 'react'
import { Box, Typography } from '@material-ui/core'
import styled from 'styled-components'

const Centering = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Component = () => (
  <>
    <Centering>
      <Typography variant="h1" style={{ marginTop: '50px' }}>
        Not Found
      </Typography>
    </Centering>
  </>
)

export default Component
